export function lessonVideos(lesson) {
  return Array.isArray(lesson?.videos) ? lesson.videos : []
}

export function lessonHasVideos(lesson) {
  return lessonVideos(lesson).length > 0
}

export function isLessonReleased(lesson) {
  const released = lesson?.released
  return released === true || released === "true" || released === 1 || released === "1"
}

export function embedVideoUrl(url) {
  if (!url) return ""

  if (url.includes("youtube")) {
    const match = url.match(/youtube\.com.*(?:\/|v=)([^&$]+)/)
    const embed = match ? `https://www.youtube.com/embed/${match[1]}` : url
    const separator = embed.includes("?") ? "&" : "?"
    return `${embed}${separator}_=${Date.now()}`
  }

  return url
}

export function renderVideoInto(player, video, lesson) {
  if (!player || !video?.link || !lesson) return false

  const embedSrc = embedVideoUrl(video.link)

  player.setAttribute("data-video", `now-${video.id}`)
  player.dataset.lesson = `now-${lesson.id}`
  player.innerHTML = `
    <div class="iframe-container">
      <iframe
        src="${embedSrc}"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  `

  return true
}
